<template>
  <div class="closed-documents-page">
    <div class="inquire-module" id="page-top">
      <a-row :gutter="24">
        <a-col :md="4" :sm="6">
          <a-range-picker v-model="dateValue" format="YYYY-MM-DD" @change="changeData" />
        </a-col>
        <a-col :md="3" :sm="6">
          <a-select labelInValue style="width: 100%;" v-model="formData.typeName" placeholder="单据类型"
            @change="selectBillType">
            <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
            <a-select-option v-for="(item, index) in typeList" :key="index">
              <span>{{ item.name }}</span>
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :md="3" :sm="6">
          <a-tooltip>
            <template slot="title" v-if="formData.contactCustomerName">
              <span>{{ formData.contactCustomerName }}</span>
            </template>
            <a-input placeholder="请输入往来单位" autoComplete="off" v-model="formData.contactCustomerName"
              @change="changeContactCustomer" @dblclick="btnReceiptModel" @pressEnter="btnReceiptModel"
              class="border-radius-input contact-customer-name-input">
              <a-tooltip slot="suffix" title @click="btnReceiptModel">
                <div style="height: 100%">
                  <img src="@/assets/image/gengduo.png" alt style="width: 12px;" />
                </div>
              </a-tooltip>
            </a-input>
          </a-tooltip>
        </a-col>
        <a-col :md="3" :sm="6">
          <a-select labelInValue style="width: 100%;" v-model="formData.outboundName" placeholder="出库仓库"
            @change="selectoutWarehouse">
            <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
            <a-select-option v-for="(item, index) in warehouseList" :key="index">
              <span>{{ item.storageName }}</span>
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :md="3" :sm="6">
          <a-select labelInValue style="width: 100%;" v-model="formData.inboundName" placeholder="入库仓库"
            @change="selectinWarehouse">
            <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
            <a-select-option v-for="(item, index) in warehouseList" :key="index">
              <span>{{ item.storageName }}</span>
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :md="3" :sm="6">
          <a-input placeholder="请输入编号/商品名称/拼音" v-model="formData.keyword" />
        </a-col>
        <a-col :md="3" :sm="6" class="button-ant-col">
          <a-button class="ant-btn-color border-arc" @click="btnInquire">查询</a-button>
          <a-button class="border-arc" @click="btnReset">重置</a-button>
        </a-col>
      </a-row>
    </div>

    <div class="closed-documents-table" :style="{height: contentHeight+'px'}">
      <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id" :customRow="rowClick"
        :scroll="{ x:1000,y: (tableHeight) }" bordered>
        <!-- 序号 -->
        <template slot="serialNum" slot-scope="text, record, index">
          <span>{{ index+1 }}</span>
        </template>
        <!-- 单据来源 -->
        <template slot="sourceOfBusiness" slot-scope="text">
          <span>{{ text==0?"门店" :"云店" }}</span>
        </template>
        <!-- 商品编号 -->
        <template slot="code" slot-scope="text">
          <a-tooltip>
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 单据类别 -->
        <template slot="type" slot-scope="text">
          <span>{{ getTypeName(text) }}</span>
        </template>
        <!-- 商品摘要 -->
        <template slot="digest" slot-scope="text" v-if="text">
          <a-tooltip>
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 商品备注 -->
        <template slot="remark" slot-scope="text" v-if="text">
          <a-tooltip>
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 操作 -->
        <template slot="operation" slot-scope="text,record">
          <span class="operation-td">
            <span style="color:#387BFC;padding-right:15px" v-has="buttonHas(record, 'CK')"
              @click="btnGoSellOrderDetails(record,1)">查看</span>
            <span class="delete-image" @click="btnDeleteOrider(text, record)"></span>
          </span>
        </template>
      </a-table>
    </div>
    <div class="pagination-box">
      <a-pagination :total="ipagination.total" :page-size="ipagination.pageSize" :current="ipagination.current"
        :show-total="ipagination.showTotal" @showSizeChange="onShowSizeChange" @change="onChangeIpagination"
        show-size-changer show-quick-jumper />
    </div>
    <!-- 选择往来单位 -->
    <receipt-model ref="receipt" @onSelectModel="onSelectModel"></receipt-model>
    <!-- 删除弹窗 -->
    <delete-modal ref="deletemodal" @confirmDeletion="confirmDeletion"></delete-modal>
  </div>
</template>
<script>
import pick from "lodash.pick";
import { list } from "../methhod/list";
import { tableWidth } from "@/mixins/tableWidth";
import { pageVoucher } from "@/utils/api";
import receiptModel from "@/components/receiptModel.vue";
import deleteModal from "@/components/module/deleteModal.vue";
export default {
  name: "closedDocuments",
  mixins: [list, tableWidth],
  components: {
    receiptModel,
    deleteModal,
  },
  data() {
    return {
      state: 5,
      columns: [
        {
          width: 80,
          title: "序号",
          align: "center",
          dataIndex: "serialNum",
          ellipsis: true,
          scopedSlots: { customRender: "serialNum" },
        },
        {
          width: 80,
          title: "来源",
          align: "center",
          dataIndex: "sourceOfBusiness",
          ellipsis: true,
          scopedSlots: { customRender: "sourceOfBusiness" },
        },
        {
          defaultWidth: 160,
          title: "单据编号",
          dataIndex: "code",
          ellipsis: true,
          scopedSlots: { customRender: "code" },
        },
        {
          defaultWidth: 120,
          title: "单据日期",
          dataIndex: "voucherDate",
          ellipsis: true,
          scopedSlots: { customRender: "voucherDate" },
        },
        {
          defaultWidth: 120,
          title: "单据类型",
          dataIndex: "type",
          ellipsis: true,
          scopedSlots: { customRender: "type" },
        },
        {
          title: "金额",
          align: "right",
          dataIndex: "amount",
          ellipsis: true,
          scopedSlots: { customRender: "amount" },
        },
        {
          defaultWidth: 100,
          title: "出库仓库",
          dataIndex: "outboundStorageName",
          ellipsis: true,
          scopedSlots: { customRender: "outboundStorageName" },
        },
        {
          defaultWidth: 100,
          title: "入库仓库",
          dataIndex: "inboundStorageName",
          ellipsis: true,
          scopedSlots: { customRender: "inboundStorageName" },
        },
        {
          defaultWidth: 100,
          title: "经办人",
          dataIndex: "transactorName",
          ellipsis: true,
          scopedSlots: { customRender: "transactorName" },
        },
        {
          defaultWidth: 120,
          title: "往来单位",
          dataIndex: "contactCustomerName",
          ellipsis: true,
          scopedSlots: { customRender: "contactCustomerName" },
        },
        {
          defaultWidth: 150,
          title: "摘要",
          dataIndex: "digest",
          ellipsis: true,
          scopedSlots: { customRender: "digest" },
        },
        {
          defaultWidth: 150,
          title: "备注",
          dataIndex: "remark",
          ellipsis: true,
          scopedSlots: { customRender: "remark" },
        },
        {
          width: 100,
          title: "操作",
          dataIndex: "operation",
          align: "center",
          ellipsis: true,
          scopedSlots: { customRender: "operation" },
        },
      ], // 表头标题
      dataSource: [], // 表格数据
      warehouseList: [], // 仓库列表
      tableHeight: "", // 表格高度
      contentHeight: "",
      urlList: {
        list: "/storage/api/voucher/pageVoucher",
      },
    };
  },
  activated() {
    // 表格高度计算
    let _that = this;
    setTimeout(function () {
      let tdHeight = document.getElementsByTagName("tr")[0].offsetHeight;
      let header = document.getElementById("header").offsetHeight;
      let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
      let pageHeight = document.getElementById("content").offsetHeight;
      let makeTop = document.getElementById("page-top").offsetHeight;
      _that.contentHeight =
        pageHeight - makeTop - header - breadcrumb - tdHeight * 0.8;
      _that.tableHeight = _that.contentHeight - tdHeight;
    }, 50);
  },
  methods: {
    // 是否显示按钮类型判断
    buttonHas(record, type) {
      // 1采购入库 2销售退货入库 3其他入库 4库存报溢 5销售出库 6采购退货出库 7其他出库 8库存报损 9库存调拨 10库存组装拆卸单 11付款单 12收款单 13其他支出单 14其他收入单
      let has = "";
      switch (record.type) {
        case "1":
          if (type == "CK") {
            has = "purchase_inbound_close_order_details";
          }
          break;
        case "2":
          if (type == "CK") {
            has = "sales_inbound_close_order_details";
          }
          break;
        case "3":
          if (type == "CK") {
            has = "library_other_enter_close_search";
          }
          break;
        case "4":
          if (type == "CK") {
            has = "library_overflow_close_search";
          }
          break;
        case "5":
          if (type == "CK") {
            has = "sales_outbound_close_order_details";
          }
          break;
        case "6":
          if (type == "CK") {
            has = "purchase_outbound_close_order_details";
          }
          break;
        case "7":
          if (type == "CK") {
            has = "library_other_out_close_search";
          }
          break;
        case "8":
          if (type == "CK") {
            has = "library_loss_close_search";
          }
          break;
        case "9":
          if (type == "CK") {
            has = "library_warehouse_close_search";
          }
          break;
        case "10":
          if (type == "CK") {
            has = "library_assembly_close_search";
          }
          break;
        case "11":
          if (type == "CK") {
            has = "finance_payment_close_search";
          }
          break;
        case "12":
          if (type == "CK") {
            has = "finance_receipt_close_search";
          }
          break;
        case "13":
          if (type == "CK") {
            has = "finance_other_expenses_close_search";
          }
          break;
        case "14":
          if (type == "CK") {
            has = "finance_other_revenue_close_search";
          }
          break;
        default:
          has = "";
      }
      return has;
    },
    // 删除按钮
    btnDeleteOrider(text, record) {
      this.$refs.deletemodal.show(record);
    },
    confirmDeletion(record) {
      this.onDeleteOrder(record, 2);
    },
    rowClick(record, index) {
      return {
        on: {
          dblclick: () => {
            this.btnGoSellOrderDetails(record, 1);
          },
        },
      };
    },
  },
};
</script>

<style lang="scss">
.closed-documents-page {
  .inquire-module {
    height: 80px;
    padding: 0px 30px;
    background-color: #ffffff;
    .ant-row {
      height: 80px !important;
      display: flex;
      align-items: center;
    }
    .ant-form-item-children {
      width: 100%;
      .ant-calendar-picker {
        width: 100%;
      }
      .ant-calendar-picker-input {
        width: 100% !important;
      }
    }
    .button-ant-col {
      display: flex;
      // align-items: center;
      .ant-btn {
        width: 80px !important;
      }
      .ant-btn-color {
        margin-right: 16px;
      }
    }
    .button-add-col {
      display: flex;
      justify-content: flex-end;
      .ant-btn {
        font-size: 16px;
        margin-left: 16px;
      }
    }
    .ant-form-item {
      margin-bottom: 0 !important;
    }
  }
  .closed-documents-table {
    margin-top: 16px;
    background-color: #ffffff;
    .ant-table-wrapper {
      padding: 0;
    }
    .ant-table-thead {
      tr {
        th {
          height: 50px;
          padding: 0 16px !important;
        }
      }
    }
    .ant-table-tbody {
      tr {
        td {
          padding: 0 10px !important;
          height: 54px;
        }
        .ant-input {
          border-radius: 0 !important;
        }
        .blank-input {
          width: 100%;
          height: 54px;
        }
        .text-overflow {
          width: 100%;
          height: 36px;
          line-height: 36px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .ant-table-footer {
      padding: 0 5px 0 0;
      td:last-child {
        border-right: 0 !important;
      }
      .ant-table-body {
        border: 0;
      }
    }
  }

  .pagination-box {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    position: fixed;
    left: 0;
    bottom: 0;
  }

  // 表格删除按钮
  .operation-td {
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    .delete-image {
      display: inline-block;
      width: 16px;
      height: 16px;
      background-image: url("../../../assets/image/cha_shanchu_color.png");
      background-size: cover;
    }
    .delete-image:hover {
      background-image: url("../../../assets/image/cha_shanchu.png");
    }
  }
}
</style>
